import { ItrackType } from '@didi/webx-js-core';
import { get } from '../request/index';
const businessResourceLog = ({ activity, trackType }) => {
    if (!activity) {
        return;
    }
    let tracks = [];
    switch (trackType) {
        case ItrackType.CLICK:
            tracks = activity.click_tracks || [];
            break;
        case ItrackType.CLOSE:
            tracks = activity.close_tracks || [];
            break;
        case ItrackType.IMP:
            tracks = activity.imp_tracks || [];
            break;
        default:
            break;
    }
    tracks.forEach((url) => {
        const data = {
            ...activity.log_data,
            st: new Date().getTime(),
        };
        get(url, {
            params: data,
        }).catch(() => { });
    });
};
export { businessResourceLog };
